// extracted by mini-css-extract-plugin
var _1 = "ChatroomStartedLine-modulechatroomStartedLine__RkedH";
export { _1 as "chatroomStartedLine" }
